<div class="container">
    <app-template [title]="'Report Template Parameter'">
        <div class="all">
            <form [formGroup]="Form" (ngSubmit)="onSubmit($event)">
                <!-- <h1 class="title">Create Report Parameter</h1> -->

              <span class="input">
                <mat-form-field>
                    <mat-label>Report Builder Template</mat-label>
                    <mat-select formControlName="reportBuilderTemplateId" matNativeControl>
                      <mat-option *ngFor="let template of buiders" [value]="template.Id">
                        {{template.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
              </span>

              <span class="input">
                <mat-form-field>
                    <mat-label>Name</mat-label>
                    <mat-select formControlName="name" matNativeControl>
                      <mat-option *ngFor="let type of types.Result" [value]="type.Name">
                        {{type.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
              </span>

              <span class="input">
                <mat-form-field>
                    <mat-label>Type</mat-label>
                    <mat-select formControlName="parameterType" matNativeControl>
                      <mat-option *ngFor="let param of params" [value]="param.Id">
                        {{param.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
              </span>

            
              <button *ngIf="!isLoading" class="button" [disabled]="Form.invalid" type="submit" mat-raised-button color="primary" > Create </button>
              <button *ngIf="isLoading" class="button" mat-raised-button color="primary" type="submit"  ><i class="fa fa-spin fa-spinner"></i>&nbsp;Create</button>
              <a routerLink="/report" class="waves-effect pull-right" style="margin-left: 20px;">
                <button type="button" class="button" mat-raised-button color="primary"> Back</button>
              </a>
            </form>
          </div>
    </app-template>
</div>
